import { render, staticRenderFns } from "./paymentsList.vue?vue&type=template&id=4d5b6d11&scoped=true&"
import script from "./paymentsList.vue?vue&type=script&lang=js&"
export * from "./paymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b6d11",
  null
  
)

export default component.exports